/*
  QOTT · Webinar offers page (wb-)
  - Countdowns: every [data-wb-countdown] (inline text) and [data-wb-boxes]
    (day/hour/min/sec boxes) count down to window.WB_OFFER.deadline, set by
    the "WB Offer timer" section. The deadline is a fixed moment, so the
    clock never resets on a return visit.
  - When the deadline passes, <html data-wb-state="ended"> flips live, the
    CSS swaps kit buttons for "Offer ended" and shows the ended message.
  - Kit buttons add the kit to the cart (US or CA product, picked by the
    section) and open the Rebuy Smart Cart, or go to /cart without Rebuy.
*/
(() => {
    if (window.WBOffers) return;

    const root = document.documentElement;
    const cfg = () => window.WB_OFFER || null;
    const pad = (n) => String(n).padStart(2, '0');

    const parts = (ms) => {
        const t = Math.max(0, Math.floor(ms / 1000));
        return { d: Math.floor(t / 86400), h: Math.floor((t % 86400) / 3600), m: Math.floor((t % 3600) / 60), s: t % 60, total: t };
    };

    const inlineText = (p, c) => {
        const sh = (c && c.short) || { d: 'd', h: 'h', m: 'm', s: 's' };
        if (c && c.format === 'hms') return `${pad(p.d * 24 + p.h)}:${pad(p.m)}:${pad(p.s)}`;
        return (p.d > 0 ? `${p.d}${sh.d} ` : '') + `${pad(p.h)}${sh.h} ${pad(p.m)}${sh.m} ${pad(p.s)}${sh.s}`;
    };

    const setState = (ended) => {
        const state = ended ? 'ended' : 'live';
        if (root.getAttribute('data-wb-state') !== state) {
            root.setAttribute('data-wb-state', state);
            document.dispatchEvent(new CustomEvent('wb:state', { detail: { state } }));
        }
    };

    const isEnded = () => {
        const c = cfg();
        if (!c || c.deadline === null) return false;
        if (c.design && c.preview === 'live') return false;
        if (c.design && c.preview === 'ended') return true;
        return Date.now() >= c.deadline;
    };

    let labelsApplied = false;
    const tick = () => {
        const c = cfg();
        const hasDeadline = Boolean(c && c.deadline !== null);
        const ended = isEnded();
        setState(ended);
        const p = hasDeadline ? parts(ended ? 0 : c.deadline - Date.now()) : null;

        document.querySelectorAll('[data-wb-countdown]').forEach((el) => {
            // No deadline set: hide countdown text (and a wrapper marked as its container).
            const wrap = el.closest('[data-wb-cd-wrap]');
            if (!hasDeadline) { if (wrap) wrap.hidden = true; el.textContent = ''; return; }
            if (wrap) wrap.hidden = false;
            el.textContent = ended ? (c.endedLabel || 'Offer ended') : inlineText(p, c);
        });

        document.querySelectorAll('[data-wb-boxes]').forEach((box) => {
            box.hidden = !hasDeadline;
            if (!hasDeadline) return;
            if (!labelsApplied && c.labels) {
                box.querySelectorAll('[data-wb-label]').forEach((l) => { const v = c.labels[l.dataset.wbLabel]; if (v) l.textContent = v; });
            }
            box.querySelectorAll('[data-wb-unit]').forEach((n) => { n.textContent = pad(p[n.dataset.wbUnit]); });
        });
        labelsApplied = true;

        // Kit buttons: belt and braces on top of the CSS swap.
        document.querySelectorAll('form[data-wb-add] [type="submit"]').forEach((b) => {
            if (ended) b.setAttribute('disabled', ''); else if (b.dataset.wbAvailable === 'true') b.removeAttribute('disabled');
        });
    };

    // ---------- Cart ----------
    const routes = () => {
        const r = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        return { add: r + 'cart/add.js', cart: r + 'cart' };
    };
    const getCart = () => fetch(routes().cart + '.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } }).then((r) => r.json());

    const openCart = async () => {
        const rebuy = window.Rebuy;
        if (rebuy && rebuy.SmartCart && typeof rebuy.SmartCart.show === 'function') {
            if (rebuy.Cart && typeof rebuy.Cart.fetchCart === 'function') { try { await rebuy.Cart.fetchCart(); } catch (e) {} }
            rebuy.SmartCart.show();
            return;
        }
        window.location.href = routes().cart;
    };

    const bindForm = (form) => {
        if (form.dataset.wbBound) return;
        form.dataset.wbBound = 'true';
        form.addEventListener('submit', async (e) => {
            e.preventDefault();
            if (isEnded()) return;
            const button = form.querySelector('[type="submit"]');
            const errorEl = form.querySelector('[data-wb-error]');
            const id = Number((form.querySelector('[name="id"]') || {}).value);
            if (!id || (button && button.classList.contains('is-loading'))) return;
            if (errorEl) { errorEl.hidden = true; errorEl.textContent = ''; }
            if (button) button.classList.add('is-loading');
            try {
                const res = await fetch(routes().add, {
                    method: 'POST',
                    credentials: 'same-origin',
                    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
                    body: JSON.stringify({ items: [{ id, quantity: 1 }] }),
                });
                const data = await res.json();
                if (!res.ok || data.status) throw new Error(data.description || data.message || 'Could not add to cart');
                let cart = null;
                try { cart = await getCart(); } catch (err) {}
                document.dispatchEvent(new CustomEvent('wb:added', { detail: { variantId: id, kit: form.dataset.wbKit || '', item: (data.items && data.items[0]) || data } }));
                if (cart) document.dispatchEvent(new CustomEvent('qott:cart-updated', { detail: { cart } }));
                await openCart();
            } catch (err) {
                console.error('WB: add to cart failed', err);
                if (errorEl) { errorEl.textContent = err.message || 'Something went wrong. Please try again.'; errorEl.hidden = false; }
            } finally {
                if (button) button.classList.remove('is-loading');
            }
        });
    };

    // ---------- Top bar cart count ----------
    const renderCount = (n) => {
        document.querySelectorAll('[data-wb-cart-count]').forEach((el) => { el.textContent = n; el.hidden = !n; });
    };
    const refreshCount = () => getCart().then((c) => renderCount(c.item_count || 0)).catch(() => {});
    const bindCartButtons = () => {
        document.querySelectorAll('[data-wb-cart-button]').forEach((btn) => {
            if (btn.dataset.wbBound) return;
            btn.dataset.wbBound = 'true';
            btn.addEventListener('click', (e) => {
                const rebuy = window.Rebuy;
                if (rebuy && rebuy.SmartCart && typeof rebuy.SmartCart.show === 'function') { e.preventDefault(); rebuy.SmartCart.show(); }
            });
        });
    };

    let timer = null;
    const init = () => {
        document.querySelectorAll('form[data-wb-add]').forEach(bindForm);
        bindCartButtons();
        tick();
        if (!timer) timer = window.setInterval(tick, 1000);
    };

    document.addEventListener('qott:cart-updated', (e) => {
        if (e.detail && e.detail.cart) renderCount(e.detail.cart.item_count || 0); else refreshCount();
    });
    document.addEventListener('rebuy:cart.change', refreshCount);
    window.addEventListener('pageshow', (e) => { if (e.persisted) { refreshCount(); tick(); } });
    // Coming back to a background tab: update at once instead of waiting a tick.
    document.addEventListener('visibilitychange', () => { if (!document.hidden) tick(); });
    // Theme editor re-renders sections without a page load.
    document.addEventListener('shopify:section:load', () => { labelsApplied = false; init(); });

    window.WBOffers = { tick, isEnded, parts, inlineText };

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
